const ja = {
  powered_by_clipLine_survey: "powered by ABILI Voice"
};
export default ja;